import React from 'react';
import type SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';
import CTA from '@redturtle/qubicaamf-theme/components/Blocks/commons/CTA';
import styles from './styles.module.css';
import type { QubicaContentProps } from '@redturtle/qubicaamf-theme/components/View/Common/utils';
import type {
  BlogExpanders,
  NewsItem,
} from '@redturtle/qubicaamf-theme/components/View/NewsTestimonialsView/NewsTestimonialView';

interface Content extends QubicaContentProps {
  '@components': BlogExpanders;
}
interface Props
  extends Omit<React.ComponentProps<typeof SlotRenderer>, 'content'> {
  content: Content;
}

const LatestNewsItem = (item: NewsItem) => {
  return (
    <li className={styles.newsListItem}>
      <div>
        <span className={styles.newsCategory}>
          {item.news_macro_type_info?.title}
        </span>
        <h4>{item.title}</h4>
      </div>

      <div className={styles.ctaWrapper}>
        <CTA
          href={item['@id']}
          openLinkInNewTab={undefined}
          ctaButtonStyle={'simple'}
          linkIcon={''}
        >
          READ MORE
        </CTA>
      </div>
    </li>
  );
};

const LatestNews = (props: Props) => {
  const { content } = props;
  const latestNews = content?.['@components']?.blog_summary.last_5_news;
  return (
    <div className={styles.container}>
      <ul className={styles.newsList}>
        {latestNews?.map((news) => (
          <LatestNewsItem key={news.title} {...news} />
        ))}
      </ul>
    </div>
  );
};

export { LatestNews };
